import { useTranslation } from 'react-i18next';

import { JSSDK_VERSION_LIST } from '@/constant';
import { useJsBridgeVersion } from '@/context/JsBridgeVersionContext';
import { Dropdown } from '@asphalt-react/selection';

export const Footer = () => {
  const { t } = useTranslation();
  const { setVersion } = useJsBridgeVersion();

  return (
    <footer className="fixed bottom-0 w-full text-center bg-[#182430] text-[#ffffff] py-6">
      <span className="py-2 text-[16px] tracking-[0.1em]">
        {t('footer-text')}
      </span>
      <div className="flex flex-row justify-center items-center gap-3">
        <Dropdown
          items={JSSDK_VERSION_LIST}
          onChange={(event) => setVersion(event.key)}
          placeholder="Select JSSDK Version"
          size="s"
        />
      </div>
    </footer>
  );
};
